// extracted by mini-css-extract-plugin
module.exports = {"common-content":"CommonContent_common-content_2aiJ1","text":"CommonContent_text_3yILu"};